export { default } from './AskAiPrompt';
